import { createSlice } from '@reduxjs/toolkit';

export const experimentation = createSlice({
  name: 'EXPERIMENTATION',
  initialState: [],
  reducers: {
    setComponentExperiments(state, action) {
      const { componentExperiments } = action.payload;
      return {
        ...state,
        componentExperiments,
      };
    },
  },
});

const { actions, reducer } = experimentation;

export const { setComponentExperiments } = actions;

export default reducer;
